import { fmtDistance } from "../api";
import type { VenueListItem } from "../types";

/**
 * 列表一行。排列（已同用戶確認）：
 *
 *     餐廳名
 *     [菜式標籤…]
 *     地址　·　電話
 *     距離
 *
 * 露天位同店舖營業時間唔喺列表出現 —— 兩者都係逐間唔同嘅細節，塞入一行會令
 * 每張卡長短不一，掃視嘅時候反而睇唔到「邊間喺邊、有幾遠」。詳細時間喺詳情頁。
 */
export default function VenueCard({
  v,
  onClick,
  showDistrict,
}: {
  v: VenueListItem;
  onClick: () => void;
  showDistrict?: boolean;
}) {
  const meta: string[] = [];
  if (v.address && showDistrict) meta.push(v.address);
  else if (v.district) meta.push(v.district);
  if (v.phone) meta.push(v.phone);

  return (
    <button className="card" onClick={onClick}>
      <div className="card__top">
        <span className="card__name">{v.name}</span>
      </div>

      <div className="card__meta">
        {v.cuisines.slice(0, 3).map((c) => (
          <span className="chip" key={c}>
            {c}
          </span>
        ))}
        {v.osa_multi && <span className="chip chip--brass">時段有幾種</span>}
        {v.confidence === "official-list-only" && (
          <span className="chip">只有官方資料</span>
        )}
      </div>

      {meta.length > 0 && (
        <div className="card__addr">{meta.join("　·　")}</div>
      )}

      {v.distance_m != null && (
        <div className="card__dist">{fmtDistance(v.distance_m)}</div>
      )}
    </button>
  );
}
